/* New version sheet: pure model. The request body and the texts of the toasts. */
import type { EnvVarVersionInput } from '@/api/endpoints';
import type { ValueState } from './ValueEditor';

interface BodyInput {
  value: ValueState;
  note: string;
  /** Number of the version being replaced (the concurrency guard); absent when the variable has none yet. */
  current: number | undefined;
}

/** A file upload travels as `valueBase64`, anything else as `value`; the note is trimmed and dropped when empty. */
export function newVersionBody({ value, note, current }: BodyInput): EnvVarVersionInput {
  return { ...(value.base64 ? { valueBase64: value.base64 } : { value: value.value }), ...(note.trim() ? { note: note.trim() } : {}), ...(current ? { expectedCurrentVersion: current } : {}) };
}

/** A version cannot be saved empty (neither text nor a picked file). */
export const isValueEmpty = (value: ValueState): boolean => !value.value && !value.base64;

export function newVersionToastDescription(approval: unknown, fingerprint: string): string {
  return approval ? 'Pending approval — builds keep using the current version' : `fingerprint ${fingerprint}`;
}

export function warningsToast(warnings: Array<{ code: string; message: string }>): { title: string; description: string } | null {
  if (warnings.length === 0) return null;
  return { title: `${warnings.length} warning${warnings.length === 1 ? '' : 's'}`, description: warnings.map((w) => `${w.code}: ${w.message}`).join(' · ') };
}

/** Who wrote a version: name, else email, else "system" (automatic writes). */
export function versionAuthor(createdBy: { name?: string | null; email?: string | null } | null | undefined): string {
  return createdBy?.name ?? createdBy?.email ?? 'system';
}
